import { render, staticRenderFns } from "./AltReserve.vue?vue&type=template&id=3bc0ff01&scoped=true&"
import script from "./AltReserve.vue?vue&type=script&lang=js&"
export * from "./AltReserve.vue?vue&type=script&lang=js&"
import style0 from "./AltReserve.vue?vue&type=style&index=0&id=3bc0ff01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc0ff01",
  null
  
)

export default component.exports